import { Valence } from "@/types/app/evaluator";
import { SelectInput } from "@components/molecules/FormikInput";
import { SelectItem } from "@components/ui/select";
import { ValenceInfoTooltip } from "./ValenceInfoTooltip";

interface Props {
  valence: Valence;
  setValence: (valence: Valence) => void;
}

export const NumberValenceSelect = ({ valence, setValence }: Props) => {
  return (
    <SelectInput
      name="valence"
      label="Valence"
      corner={<ValenceInfoTooltip />}
      value={valence}
      setValue={(v) => setValence(v as Valence)}
    >
      {(["positive", "neutral", "negative"] as const).map((valence) => (
        <SelectItem key={valence} value={valence}>
          {valenceToNumberText(valence)}
        </SelectItem>
      ))}
    </SelectInput>
  );
};

const valenceToNumberText = (valence: Valence): string => {
  switch (valence) {
    case "positive":
      return "Higher value is better";
    case "neutral":
      return "Neutral";
    case "negative":
      return "Lower value is better";
    default:
      const exhaustiveCheck: never = valence;
      throw new Error("unreachable");
  }
};
